import 'dayjs/locale/es'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'
import { Button, Space, Typography } from 'antd'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useDashboardFilters } from '@contexts'

import { FilterGroup } from './styled'

dayjs.extend(isoWeek)
dayjs.locale('es')

const DaySelectorText = styled(Typography.Text)`
  color: ${({ theme }) => theme.primaryColor};
  font-size: 1.25rem;
  font-weight: 700;
  min-width: 72px;
  text-align: center;
`

const DaySelector = () => {
  const { t } = useTranslation()
  const { weekStart, selectedDay, setSelectedDay } = useDashboardFilters()

  const { monday, sunday } = useMemo(() => {
    const m = dayjs(weekStart).isoWeekday(1).startOf('day')
    return { monday: m, sunday: m.add(6, 'day').endOf('day') }
  }, [weekStart])

  const current = dayjs(selectedDay).startOf('day')
  const canGoPrev = current.isAfter(monday, 'day')
  const canGoNext = current.isBefore(sunday, 'day')

  const goPrev = () => {
    if (!canGoPrev) return
    setSelectedDay(current.subtract(1, 'day').toDate())
  }

  const goNext = () => {
    if (!canGoNext) return
    setSelectedDay(current.add(1, 'day').toDate())
  }

  return (
    <FilterGroup>
      <Space size={4} align="center">
        <Button
          type="text"
          size="small"
          icon={<LeftOutlined />}
          disabled={!canGoPrev}
          onClick={goPrev}
          aria-label={t('admin_router.dashboard.day_prev')}
        />
        <DaySelectorText>{current.format('DD/MM/YY')}</DaySelectorText>
        <Button
          type="text"
          size="small"
          icon={<RightOutlined />}
          disabled={!canGoNext}
          onClick={goNext}
          aria-label={t('admin_router.dashboard.day_next')}
        />
      </Space>
    </FilterGroup>
  )
}

export { DaySelector }
